var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      © "+_vm._s(_vm.year)+" made with "),_c('i',{staticClass:"tim-icons icon-heart-2"}),_vm._v(" for a better web. v"+_vm._s(_vm.version)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }